<template>
  <div id="home">
    <div class="hero">
      <div class="container">
        <el-row type="flex" justify="center">
          <el-col :span="24">
            <h1>Automated Bag Busting Add-on For ProfitTrailer</h1>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="24">
            <h2>Harness the power of volatile markets by using automated mathematics</h2>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="24">
            <h3>Real-time Losses Recovered</h3>
          </el-col>
        </el-row>
        <el-row v-if="recovered" type="flex" justify="center">
          <el-col :span="6">
            <h4>BTC</h4><br><h5>₿{{ recovered.BTC | currency }}</h5>
          </el-col>
          <el-col :span="6">
            <h4>ETH</h4><br><h5>Ξ{{ recovered.ETH | currency }}</h5>
          </el-col>
          <el-col :span="6">
            <h4>USDT</h4><br><h5>${{ recovered.USDT | currency }}</h5>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="6">
            <router-link to="/buy">
              <el-button to="/buy" type="primary" class="btn btn-lg btn-primary btn-block">Buy Now</el-button>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </div>
    <features />
    <div class="block app-screens">
      <div class="container-fluid">
        <el-carousel arrow="always" height="940px" :interval="5000">
          <el-carousel-item>
            <img src="/images/screen-activate.png" />
          </el-carousel-item>
          <el-carousel-item>
            <img src="/images/screen-defend.png" />
          </el-carousel-item>
          <el-carousel-item>
            <img src="/images/screen-defending.png" />
          </el-carousel-item>
          <el-carousel-item>
            <img src="/images/screen-holdings.png" />
          </el-carousel-item>
          <el-carousel-item>
            <img src="/images/screen-settings.png" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <pricing />
  </div>
</template>

<script>
import api from '@/lib/api'
import referral from '@/lib/referral'
import Features from './Features'
import Pricing from './Pricing'

export default {
  name: "Home",
  props: [
    'referral'
  ],
  components: {
    Features,
    Pricing
  },
  filters: {
    currency(val) {
      return parseFloat(val).toLocaleString('en', {
        useGrouping: true,
        minimumFractionDigits: 2
      })
    }
  },
  data() {
    return {
      recovered: null,
      slide: 0,
      sliding: null
    }
  },
  async mounted() {
    if (this.referral) {
      referral.set(this.referral)
    }
    this.recovered = await api.recovered()
  }
}
</script>

<style lang="scss">
#home {
  .hero {
    position: relative;
    overflow: hidden;
    padding: 170px 0 300px 0;
    background: url('/images/hero.jpg') no-repeat;
    background-size: cover;
    text-align: center;
    color: #fff;
    h1 {
      font-weight: bold;
      font-size: 28px;
    }
    h2 {
      font-weight: 400;
      font-size: 22px;
      color: rgba(255,255,255,0.7);
      margin-bottom: 22px;
    }
    h3 {
      margin-top: 60px;
      font-weight: bold;
      font-size: 17px;
      color: #efefef;
      margin-bottom: 20px;
    }
    h4 {
      font-weight: bold;
      font-size: 26px;
    }
    h5 {
      font-weight: 400;
      font-size: 54px;
    }
    .btn-primary {
      margin-top: 60px;
      background-color: rgba(0,0,0,0);
      border: 3px solid #fff;
      width: 100%;
      text-transform: uppercase;
      font-weight: bold;
      padding: 12px 20px;
      font-size: 18px;
    }
  }

  .app-screens {
    background-color: #222;
    .el-carousel {
      padding: 20px 0;
    }
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>
